import { AnalyticsIntegrations, fireAnalyticsEvent } from '../helpers/fireAnalyticsEvent'
import { Order_Direction } from '@dtx-company/flow-codegen/src/page/generated.types'
import { fireHeapEvent, fireOptimizelyEvent } from '../helpers'
import eventNames from '../constants/templatesStore'

export const events = {
  Templates_Clicked_TemplateCard(properties: {
    templateName?: string
    templateCategory?: string
    templateId?: string
  }): void {
    fireOptimizelyEvent(eventNames.Templates_Clicked_TemplateCard)
    fireHeapEvent(eventNames.Templates_Clicked_TemplateCard, properties)
  },
  Templates_Clicked_FormatFilter(formatName: string): void {
    fireHeapEvent(eventNames.Templates_Clicked_FormatFilter, { formatName })
  },
  Templates_Clicked_CategoryFilter(categoryName: string): void {
    fireHeapEvent(eventNames.Templates_Clicked_CategoryFilter, { categoryName })
  },
  Templates_Deselected_CategoryFilter(categoryName: string): void {
    fireHeapEvent(eventNames.Templates_Deselected_CategoryFilter, { categoryName })
  },
  Templates_Reset_CategoryFilter(): void {
    fireHeapEvent(eventNames.Templates_Reset_CategoryFilter)
  },
  Templates_Clicked_CustomizationOptionsFilter(optionName: string): void {
    fireHeapEvent(eventNames.Templates_Clicked_CustomizationOptionsFilter, { optionName })
  },
  Templates_Clicked_PrintOptionsFilter(optionName: string): void {
    fireHeapEvent(eventNames.Templates_Clicked_PrintOptionsFilter, { optionName })
  },
  Templates_Clicked_SeeMoreFormats(): void {
    fireHeapEvent(eventNames.Templates_Clicked_SeeMoreFormats)
  },
  Templates_Clicked_SeeMoreCategories(): void {
    fireHeapEvent(eventNames.Templates_Clicked_SeeMoreCategories)
  },
  Templates_Clicked_SeeAllTemplates(categoryName: string): void {
    fireHeapEvent(eventNames.Templates_Clicked_SeeAllTemplates, { categoryName })
  },
  Templates_Uploaded_TemplateLogo(): void {
    fireHeapEvent(eventNames.Templates_Uploaded_TemplateLogo)
  },
  Templates_Input_ScanDestination(): void {
    fireHeapEvent(eventNames.Templates_Input_ScanDestination)
  },
  Templates_Clicked_UploadScanDestinationFile(): void {
    fireHeapEvent(eventNames.Templates_Clicked_UploadScanDestinationFile)
  },
  Templates_Clicked_SignUp(): void {
    fireHeapEvent(eventNames.Templates_Clicked_SignUp)
  },
  Templates_Clicked_TemplateSizeButton(templateSize: string): void {
    fireHeapEvent(eventNames.Templates_Clicked_TemplateSizeButton, { templateSize })
  },
  Templates_Clicked_SelectFlowcodeButton(): void {
    fireHeapEvent(eventNames.Templates_Clicked_SelectFlowcodeButton)
  },
  Templates_Clicked_FlowcodeInSelectFlowcodeModal(flowcodeId: string): void {
    fireHeapEvent(eventNames.Templates_Clicked_FlowcodeInSelectFlowcodeModal, { flowcodeId })
  },
  Templates_Clicked_OrderPrintButton(templateId: string): void {
    fireHeapEvent(eventNames.Templates_Clicked_OrderPrintButton, { templateId })
  },
  Templates_Clicked_DownloadTemplateButton(): void {
    fireHeapEvent(eventNames.Templates_Clicked_DownloadTemplateButton)
  },
  Templates_Clicked_EmailTemplateButton(): void {
    fireHeapEvent(eventNames.Templates_Clicked_EmailTemplateButton)
  },
  Templates_Clicked_PrintTemplateButton(): void {
    fireHeapEvent(eventNames.Templates_Clicked_PrintTemplateButton)
  },
  Core_TemplatesEditor_Typed_InputtedText(): void {
    fireHeapEvent(eventNames.Core_TemplatesEditor_Typed_InputtedText)
  },
  Core_TemplatesEditor_Clicked_BackButton(): void {
    fireHeapEvent(eventNames.Core_TemplatesEditor_Clicked_BackButton)
  },
  Templates_Clicked_Template_FAQs_Button(): void {
    fireHeapEvent(eventNames.Templates_Clicked_Template_FAQs_Button)
  },
  Templates_Editor_Clicked_RemoveFlowcodeButton(): void {
    fireHeapEvent(eventNames.Templates_Editor_Clicked_RemoveFlowcodeButton)
  },
  Templates_Clicked_Load_More_Button(args: {
    templateCategoryId: string | undefined
    productId: string | undefined
  }): void {
    fireHeapEvent(eventNames.Templates_Clicked_Load_More_Button, { ...args })
  },
  PrintTemplates_TemplateStore_Viewed_SignUpModal(args: {
    templateCategoryId: string | undefined
    productId: string | undefined
  }): void {
    fireHeapEvent(eventNames.PrintTemplates_TemplateStore_Viewed_SignUpModal, { ...args })
  },
  PrintTemplates_TemplateStore_Signupmodal_Clicked_GetStartedButton(args: {
    templateCategoryId: string | undefined
    productId: string | undefined
  }): void {
    fireHeapEvent(eventNames.PrintTemplates_TemplateStore_Signupmodal_Clicked_GetStartedButton, {
      ...args
    })
  },
  Store_Templates_TemplateEditor_Clicked_Create_Flowcode_Btn(args: {
    templateId?: string
    productId?: string
  }): void {
    fireHeapEvent(eventNames.Store_Templates_TemplateEditor_Clicked_Create_Flowcode_Btn, { args })
  },
  Store_Templates_TemplateEditor_Project_Data_Changed(args: {
    templateId: string
    productId: string
    diff: string
  }): void {
    fireHeapEvent(eventNames.Store_Templates_TemplateEditor_Project_Data_Changed, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_CardPermissionInfo(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_CardPermissionInfo, args)
  },
  Templates_YourTemplates_All_FlowpageTemplates_Clicked_CardPermissionInfo(args: {
    templateId: string
    templateName: string
  }): void {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_All_FlowpageTemplates_Clicked_CardPermissionInfo,
      args
    )
  },
  Templates_Discover_Flowcodes_Clicked_ShowMoreButton(): void {
    fireHeapEvent(eventNames.Templates_Discover_Flowcodes_Clicked_ShowMoreButton)
  },
  Templates_Discover_Flowcodes_Clicked_Template(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_Discover_Flowcodes_Clicked_Template, args)
  },
  Templates_Discover_Flowpages_Clicked_Template(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_Discover_Flowpages_Clicked_Template, args)
  },
  Templates_Discover_Flowpages_Clicked_CardPermissionInfo(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_Discover_Flowpages_Clicked_CardPermissionInfo, args)
  },
  Templates_Discover_Flowpages_Clicked_PreviewTemplateButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_Discover_Flowpages_Clicked_PreviewTemplateButton, args)
  },
  Templates_Discover_Flowpages_Clicked_UseTemplateButton(args: {
    templateId: string
    templateName: string
  }) {
    fireAnalyticsEvent(eventNames.Templates_Discover_Flowpages_Clicked_UseTemplateButton, args, [
      AnalyticsIntegrations.HEAP,
      AnalyticsIntegrations.INTERCOM
    ])
  },

  Templates_Discover_Flowpages_Clicked_ShowMoreButton() {
    fireHeapEvent(eventNames.Templates_Discover_Flowpages_Clicked_ShowMoreButton)
  },
  Templates_Discover_All_FlowcodeTemplates_Clicked_SeeAll() {
    fireHeapEvent(eventNames.Templates_Discover_All_FlowcodeTemplates_Clicked_SeeAll)
  },
  Templates_Discover_All_FlowpageTemplates_Clicked_SeeAll() {
    fireHeapEvent(eventNames.Templates_Discover_All_FlowpageTemplates_Clicked_SeeAll)
  },
  Templates_Discover_All_FlowcodeTemplates_Clicked_SeeAllCard() {
    fireHeapEvent(eventNames.Templates_Discover_All_FlowcodeTemplates_Clicked_SeeAllCard)
  },
  Templates_Discover_All_FlowpageTemplates_Clicked_SeeAllCard() {
    fireHeapEvent(eventNames.Templates_Discover_All_FlowpageTemplates_Clicked_SeeAllCard)
  },
  Templates_Discover_All_FlowcodeTemplates_Clicked_Template(args: {
    templateId?: string
    templateName?: string
  }) {
    fireHeapEvent(eventNames.Templates_Discover_All_FlowcodeTemplates_Clicked_Template, args)
  },
  Templates_Discover_All_FlowpageTemplates_Clicked_Template(args: {
    templateId?: string
    templateName?: string
  }) {
    fireHeapEvent(eventNames.Templates_Discover_All_FlowpageTemplates_Clicked_Template, args)
  },
  Templates_Discover_All_FlowpageTemplates_Clicked_CardPermissionInfo(args: {
    templateId?: string
    templateName?: string
  }) {
    fireHeapEvent(
      eventNames.Templates_Discover_All_FlowpageTemplates_Clicked_CardPermissionInfo,
      args
    )
  },
  Templates_Discover_All_FlowpageTemplates_Clicked_PreviewTemplateButton(args: {
    templateId?: string
    templateName?: string
  }) {
    fireHeapEvent(
      eventNames.Templates_Discover_All_FlowpageTemplates_Clicked_PreviewTemplateButton,
      args
    )
  },
  Templates_Discover_All_FlowpageTemplates_ClickedUseTemplateButton(args: {
    templateId?: string
    templateName?: string
  }) {
    fireHeapEvent(
      eventNames.Templates_Discover_All_FlowpageTemplates_ClickedUseTemplateButton,
      args
    )
  },
  Templates_Discover_All_FlowcodeTemplates_Clicked_ScrollArrow(args: {
    direction: 'left' | 'right'
  }) {
    fireHeapEvent(eventNames.Templates_Discover_All_FlowcodeTemplates_Clicked_ScrollArrow, args)
  },
  Templates_Discover_All_FlowpageTemplates_Clicked_ScrollArrow(args: {
    direction: 'left' | 'right'
  }) {
    fireHeapEvent(eventNames.Templates_Discover_All_FlowpageTemplates_Clicked_ScrollArrow, args)
  },
  Templates_Discover_All_Placements_Templates_Clicked_SeeAllCard(args: {
    productId?: string
    productName?: string
  }) {
    fireHeapEvent(eventNames.Templates_Discover_All_Placements_Templates_Clicked_SeeAllCard, args)
  },
  Templates_Discover_All_Placements_Templates_Clicked_SeeAll(args: {
    productId?: string
    productName?: string
  }) {
    fireHeapEvent(eventNames.Templates_Discover_All_Placements_Templates_Clicked_SeeAll, args)
  },
  Templates_Discover_All_Placements_Templates_Clicked_Template(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_Discover_All_Placements_Templates_Clicked_Template, args)
  },
  Templates_Discover_All_Placements_Templates_Clicked_ScrollArrow(args: {
    direction: 'left' | 'right'
  }) {
    fireHeapEvent(eventNames.Templates_Discover_All_Placements_Templates_Clicked_ScrollArrow, args)
  },
  Templates_Discover_Placements_Products_Clicked_SeeAll(args: { isPlacementsPage: boolean }) {
    fireHeapEvent(eventNames.Templates_Discover_Placements_Products_Clicked_SeeAll, args)
  },
  Templates_Discover_Placements_Products_Clicked_SeeAllCard(args: { isPlacementsPage: boolean }) {
    fireHeapEvent(eventNames.Templates_Discover_Placements_Products_Clicked_SeeAllCard, args)
  },
  Templates_Discover_Placements_Products_Clicked_Product(args: {
    productId?: string
    productName?: string
    isPlacementsPage: boolean
  }) {
    fireHeapEvent(eventNames.Templates_Discover_Placements_Products_Clicked_Product, args)
  },
  Templates_Discover_Placements_Products_Clicked_ScrollArrow(args: {
    direction: 'left' | 'right'
    isPlacementsPage: boolean
  }) {
    fireHeapEvent(eventNames.Templates_Discover_Placements_Products_Clicked_ScrollArrow, args)
  },
  Templates_Discover_Placements_PopularTemplates_Clicked_SeeAllCard(args: {
    isPlacementsPage: boolean
  }) {
    fireHeapEvent(
      eventNames.Templates_Discover_Placements_PopularTemplates_Clicked_SeeAllCard,
      args
    )
  },
  Templates_Discover_Placements_PopularTemplates_Clicked_SeeAll(args: {
    isPlacementsPage: boolean
  }) {
    fireHeapEvent(eventNames.Templates_Discover_Placements_PopularTemplates_Clicked_SeeAll, args)
  },
  Templates_Discover_Placements_PopularTemplates_Clicked_Template(args: {
    templateId: string
    templateName: string
    isPlacementsPage: boolean
  }) {
    fireHeapEvent(eventNames.Templates_Discover_Placements_PopularTemplates_Clicked_Template, args)
  },
  Templates_Discover_Placements_PopularTemplates_Clicked_ScrollArrow(args: {
    direction: 'left' | 'right'
    isPlacementsPage: boolean
  }) {
    fireHeapEvent(
      eventNames.Templates_Discover_Placements_PopularTemplates_Clicked_ScrollArrow,
      args
    )
  },
  Templates_YourTemplates_All_Clicked_Flowcodes_SeeAll() {
    fireHeapEvent(eventNames.Templates_YourTemplates_All_Clicked_Flowcodes_SeeAll)
  },
  Templates_YourTemplates_All_Clicked_Flowcodes_SeeAllCard() {
    fireHeapEvent(eventNames.Templates_YourTemplates_All_Clicked_Flowcodes_SeeAllCard)
  },
  Templates_YourTemplates_All_FlowcodeTemplates_Clicked_ScrollArrow(args: {
    direction: 'left' | 'right'
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_All_FlowcodeTemplates_Clicked_ScrollArrow,
      args
    )
  },
  Templates_YourTemplates_All_FlowcodeTemplates_Clicked_Template(args: {
    templateId?: string
    templateName?: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_All_FlowcodeTemplates_Clicked_Template, args)
  },
  Templates_YourTemplates_All_FlowpageTemplates_Clicked_PreviewTemplateButton(args: {
    templateId?: string
    templateName?: string
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_All_FlowpageTemplates_Clicked_PreviewTemplateButton,
      args
    )
  },
  Templates_YourTemplates_All_FlowpageTemplates_ClickedUseTemplateButton(args: {
    templateId?: string
    templateName?: string
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_All_FlowpageTemplates_ClickedUseTemplateButton,
      args
    )
  },
  Templates_YourTemplates_All_Clicked_Flowpages_SeeAll() {
    fireHeapEvent(eventNames.Templates_YourTemplates_All_Clicked_Flowpages_SeeAll)
  },
  Templates_YourTemplates_All_Clicked_Flowpages_SeeAllCard() {
    fireHeapEvent(eventNames.Templates_YourTemplates_All_Clicked_Flowpages_SeeAllCard)
  },
  Templates_YourTemplates_All_FlowpageTemplates_Clicked_ScrollArrow(args: {
    direction: 'left' | 'right'
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_All_FlowpageTemplates_Clicked_ScrollArrow,
      args
    )
  },
  Templates_YourTemplates_All_FlowpageTemplates_Clicked_Template(args: {
    templateId?: string
    templateName?: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_All_FlowpageTemplates_Clicked_Template, args)
  },
  Templates_YourTemplates_All_Clicked_CreateTemplateButton() {
    fireHeapEvent(eventNames.Templates_YourTemplates_All_Clicked_CreateTemplateButton)
  },
  Templates_Mobile_TopNav_Clicked_BackArrow() {
    fireHeapEvent(eventNames.Templates_Mobile_TopNav_Clicked_BackArrow)
  },
  Templates_Mobile_TopNav_Clicked_SwitchButton(args: {
    selectedMenu: string
    routingToYourCreate: boolean
  }) {
    fireHeapEvent(eventNames.Templates_Mobile_TopNav_Clicked_SwitchButton, args)
  },
  Templates_Mobile_TopNav_Clicked_TabMenu(args: {
    menuItem: string
    category: 'discover' | 'yourTemplates'
  }) {
    fireHeapEvent(eventNames.Templates_Mobile_TopNav_Clicked_TabMenu, args)
  },
  Templates_Mobile_TopNav_Clicked_CreateTemplatePlusButton() {
    fireHeapEvent(eventNames.Templates_Mobile_TopNav_Clicked_CreateTemplatePlusButton)
  },
  Templates_CreateTemplateMenu_Clicked_FlowcodeTemplate() {
    fireHeapEvent(eventNames.Templates_CreateTemplateMenu_Clicked_FlowcodeTemplate)
  },
  Templates_CreateTemplateMenu_Clicked_FlowpageTemplate() {
    fireHeapEvent(eventNames.Templates_CreateTemplateMenu_Clicked_FlowpageTemplate)
  },
  Templates_CreateTemplateMenu_Clicked_RequestCustomCode() {
    fireHeapEvent(eventNames.Templates_CreateTemplateMenu_Clicked_RequestCustomCode)
  },
  Templates_YourTemplates_Flowpage_RenameTemplate_Clicked_RenameButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowpage_RenameTemplate_Clicked_RenameButton,
      args
    )
  },
  Templates_YourTemplates_Flowpage_RenameTemplate_Clicked_CancelButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowpage_RenameTemplate_Clicked_CancelButton,
      args
    )
  },
  Templates_YourTemplates_Flowpage_DeleteTemplate_Clicked_DeleteButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowpage_DeleteTemplate_Clicked_DeleteButton,
      args
    )
  },
  Templates_YourTemplates_Flowpage_DeleteTemplate_Clicked_CancelButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowpage_DeleteTemplate_Clicked_CancelButton,
      args
    )
  },
  Templates_YourTemplates_Flowpages_Clicked_CardMenuButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_CardMenuButton, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_CardMenuPreviewButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_CardMenuPreviewButton, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_CardMenuUseTemplateButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowpages_Clicked_CardMenuUseTemplateButton,
      args
    )
  },
  Templates_YourTemplates_Flowpages_Clicked_CardMenuShare(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_CardMenuShare, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_CardMenuRename(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_CardMenuRename, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_CardMenuDelete(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_CardMenuDelete, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_CardMenuEdit(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_CardMenuEdit, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_TemplateCard(args: { templateId: string }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_TemplateCard, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_SearchButton() {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_SearchButton)
  },
  Templates_YourTemplates_Flowpages_Clicked_SearchDoneButton() {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_SearchDoneButton)
  },
  Templates_YourTemplates_Flowpages_Clicked_ClearSearchButton() {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_ClearSearchButton)
  },
  Templates_YourTemplates_Flowpages_Searched_Templates(args: { searchText: string }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Searched_Templates, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_ShowMoreButton() {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_ShowMoreButton)
  },
  Templates_YourTemplates_Flowpages_Clicked_TemplatesTypeFilterChip(args: { label: string }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowpages_Clicked_TemplatesTypeFilterChip,
      args
    )
  },
  Templates_YourTemplates_Flowpages_Clicked_SortByButton() {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_SortByButton)
  },
  Templates_YourTemplates_Flowpages_Clicked_SortDirectionButton(args: {
    direction: Order_Direction
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_SortDirectionButton, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_SortOption(args: { orderBy: string }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_SortOption, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_CreatePageTemplateButton(args: {
    upgradeRequested: boolean
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowpages_Clicked_CreatePageTemplateButton,
      args
    )
  },
  Templates_YourTemplates_Flowpages_Clicked_CreateAFlowpageTemplateButton(args: {
    upgradeRequested: boolean
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowpages_Clicked_CreateAFlowpageTemplateButton,
      args
    )
  },
  Templates_YourTemplates_Flowcodes_Clicked_TemplatesTypeFilterChip(args: {
    label: 'savedDesigns' | 'customAssigned'
  }) {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowcodes_Clicked_TemplatesTypeFilterChip,
      args
    )
  },
  Templates_YourTemplates_Flowcodes_Clicked_CreateCodeTemplateButton() {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowcodes_Clicked_CreateCodeTemplateButton)
  },
  Templates_YourTemplates_Flowcodes_Clicked_CreateAFlowcodeTemplateButton() {
    fireHeapEvent(
      eventNames.Templates_YourTemplates_Flowcodes_Clicked_CreateAFlowcodeTemplateButton
    )
  },
  Templates_YourTemplates_Flowcodes_Clicked_Template(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowcodes_Clicked_Template, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_PreviewTemplateButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_PreviewTemplateButton, args)
  },
  Templates_YourTemplates_Flowpages_Clicked_UseTemplateButton(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_YourTemplates_Flowpages_Clicked_UseTemplateButton, args)
  },
  Templates_CreateCodeTemplateModal_Selected_Flowcode(args: {
    batchId: string
    nickname?: string
    searchText: string
  }) {
    fireHeapEvent(eventNames.Templates_CreateCodeTemplateModal_Selected_Flowcode, args)
  },
  Templates_CreateCodeTemplateModal_Entered_TemplateName(args: { templateName: string }) {
    fireHeapEvent(eventNames.Templates_CreateCodeTemplateModal_Entered_TemplateName, args)
  },
  Templates_CreateCodeTemplateModal_Clicked_Cancel_Button() {
    fireHeapEvent(eventNames.Templates_CreateCodeTemplateModal_Clicked_Cancel_Button)
  },
  Templates_CreateCodeTemplateModal_Clicked_CreateTemplateButton(args: {
    batchId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_CreateCodeTemplateModal_Clicked_CreateTemplateButton, args)
  },
  Templates_CreateCodeTemplateModal_Clicked_DismissButton(args: { hasNoCodes: boolean }) {
    fireHeapEvent(eventNames.Templates_CreateCodeTemplateModal_Clicked_DismissButton, args)
  },
  Templates_CreateCodeTemplateModal_Clicked_CreateFlowcodeButton() {
    fireHeapEvent(eventNames.Templates_CreateCodeTemplateModal_Clicked_CreateFlowcodeButton)
  },
  Templates_Create_Page_Template_Share_Modal_Clicked_ShareButton(args: { templateId: string }) {
    fireHeapEvent(eventNames.Templates_Create_Page_Template_Share_Modal_Clicked_ShareButton, args)
  },
  Templates_Create_Page_Template_Share_Modal_Clicked_SearchInput(args: { templateId: string }) {
    fireHeapEvent(eventNames.Templates_Create_Page_Template_Share_Modal_Clicked_SearchInput, args)
  },
  Templates_Create_Page_Template_Share_Modal_Selected_Permission(args: {
    permission: string
    templateId: string
  }) {
    fireHeapEvent(eventNames.Templates_Create_Page_Template_Share_Modal_Selected_Permission, args)
  },
  Templates_Create_Page_Template_Share_Modal_Clicked_ShareWithEveryoneCheckbox(args: {
    templateId: string
    checked: boolean
  }) {
    fireHeapEvent(
      eventNames.Templates_Create_Page_Template_Share_Modal_Clicked_ShareWithEveryoneCheckbox,
      args
    )
  },
  Templates_Create_Page_Template_Share_Modal_Clicked_PermissionDropdown(args: {
    templateId: string
  }) {
    fireHeapEvent(
      eventNames.Templates_Create_Page_Template_Share_Modal_Clicked_PermissionDropdown,
      args
    )
  },
  Templates_CreatePageTemplateModal_Selected_Flowpage(args: {
    pageId: string
    searchText: string
  }) {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Selected_Flowpage, args)
  },
  Templates_CreatePageTemplateModal_Entered_TemplateName(args: {
    pageId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Entered_TemplateName, args)
  },
  Templates_CreatePageTemplateModal_Entered_Note(args: { pageId?: string }) {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Entered_Note, args)
  },
  Templates_CreatePageTemplateModal_Clicked_ShareTemplate(args: {
    pageId: string
    checked: boolean
  }) {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Clicked_ShareTemplate, args)
  },
  Templates_CreatePageTemplateModal_Clicked_SubmitCopy(args: { pageId: string; checked: boolean }) {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Clicked_SubmitCopy, args)
  },
  Templates_CreatePageTemplateModal_Clicked_PropagateChanges(args: {
    pageId: string
    checked: boolean
  }) {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Clicked_PropagateChanges, args)
  },
  Templates_CreatePageTemplateModal_Clicked_CancelButton() {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Clicked_CancelButton)
  },
  Templates_CreatePageTemplateModal_Clicked_CreateTemplate_Button(args: {
    pageId: string
    templateName?: string
  }) {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Clicked_CreateTemplate_Button, args)
  },
  Templates_CreatePageTemplateModal_Clicked_DismissButton(args: { hasNoPages: boolean }) {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Clicked_DismissButton, args)
  },
  Templates_CreatePageTemplateModal_Clicked_CreateFlowpageButton() {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Clicked_CreateFlowpageButton)
  },
  Templates_MaxAssetsAlert_Clicked_CreateMoreButton(args: {
    userReachedCodeLimit: boolean
    userHasReachedPageLimit: boolean
  }) {
    fireHeapEvent(eventNames.Templates_MaxAssetsAlert_Clicked_CreateMoreButton, args)
  },
  Templates_YourCreate_Clicked_CreateCodeTemplateButton() {
    fireHeapEvent(eventNames.Templates_YourCreate_Clicked_CreateCodeTemplateButton)
  },
  Templates_YourCreate_Clicked_CreatePageTemplateButton() {
    fireHeapEvent(eventNames.Templates_YourCreate_Clicked_CreatePageTemplateButton)
  },
  Templates_YourCreate_Clicked_UpgradeToCreatePageTemplateButton() {
    fireHeapEvent(eventNames.Templates_YourCreate_Clicked_UpgradeToCreatePageTemplateButton)
  },
  Templates_CreatePageTemplateModal_Creation_Success(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_CreatePageTemplateModal_Creation_Success, args)
  },
  Templates_CreateCodeTemplateModal_Creation_Success(args: {
    templateId: string
    templateName: string
  }) {
    fireHeapEvent(eventNames.Templates_CreateCodeTemplateModal_Creation_Success, args)
  }
}

export default events
